import React from "react";
import Spinner from "react-js-loader";

const TURQUOISE = "#25f4df";
const DARK_TURQUOISE = "#063f3b";

function isLightColor(value) {
  const hex = String(value || "").trim().replace("#", "");
  if (!/^[0-9a-f]{6}$/i.test(hex)) return false;
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return ((r * 299) + (g * 587) + (b * 114)) / 1000 > 155;
}

export default function GlassSpinner({ size = 76, background = "#071416" }) {
  const darkAccent = isLightColor(background);
  const accent = darkAccent ? DARK_TURQUOISE : TURQUOISE;

  return (
    <div
      role="status"
      aria-label="Cargando"
      style={{
        width: size + 28,
        height: size + 28,
        margin: "0 auto",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(145deg, rgba(255,255,255,.42), rgba(255,255,255,.1))",
        border: "1px solid rgba(255,255,255,.62)",
        boxShadow: `inset 0 2px 2px rgba(255,255,255,.7), inset 0 -8px 18px rgba(0,70,66,.18), 0 9px 0 ${accent}38, 0 18px 38px ${accent}45`,
        backdropFilter: "blur(16px) saturate(155%)",
        WebkitBackdropFilter: "blur(16px) saturate(155%)",
      }}
    >
      <Spinner type="bubble-top" bgColor={accent} color={accent} size={size} />
    </div>
  );
}
